import { GRAPHQL_ENDPOINT } from './environment';

export function logEvent(telemetry: any, event: string) {
  if (telemetry) {
    telemetry.reportEvent('Connect', event, GRAPHQL_ENDPOINT);
  } else {
    console.error(`Telemetry service hasn't been provided`);
  }
}
